<aside class="ds-sidebar" [class.collapsed]="collapsed">

  <a class="ds-brand" routerLink="/">
    <img class="ds-brand-logo" src="/assets/icons/header/legalStack.svg" alt="LegalStack" />
    <span class="ds-brand-mark">L</span>
  </a>

  <nav class="ds-nav">
    <div class="ds-group" *ngFor="let group of groups">
      <p class="ds-group-title">{{ group.title }}</p>

      <a *ngFor="let item of group.items" class="ds-link" routerLink="/{{ item.route }}"
        [class.active]="isActive(item.route)"
        [attr.title]="collapsed ? item.label : null" (click)="onNavigate()">
        <span class="ds-link-ico"><i [class]="item.icon"></i></span>
        <span class="ds-link-label">{{ item.label }}</span>
      </a>
    </div>
  </nav>

  <div class="ds-user">
    <span class="ds-user-avatar">{{ initial }}</span>
    <div class="ds-user-meta">
      <span class="ds-user-name">{{ gS.userName || 'My Account' }}</span>
      <span class="ds-user-sub" *ngIf="gS.userData?.email">{{ gS.userData?.email }}</span>
    </div>
    <button type="button" class="ds-user-logout" (click)="logout()" aria-label="Logout" title="Logout">
      <i class="fa-solid fa-right-from-bracket"></i>
    </button>
  </div>

</aside>
